import React, { createContext, useContext } from 'react'
import { RegisteredTests } from '../ab-tests/utils/testRegistry'

type ExperimentsContextValue = {
  [testKey in RegisteredTests]: any
}
interface ExperimentsProviderProps {
  children: React.ReactNode
}

const ExperimentsContext = createContext<ExperimentsContextValue>({})

const ExperimentsProvider = ({ children }: ExperimentsProviderProps) => {
  const value = {}
  return <ExperimentsContext.Provider value={value}>{children}</ExperimentsContext.Provider>
}

export const useExperimentsContext = () => useContext(ExperimentsContext)

export default ExperimentsProvider
